import { render, staticRenderFns } from "./PDPGalleryModal.vue?vue&type=template&id=1d4a42de&scoped=true"
import script from "./PDPGalleryModal.vue?vue&type=script&lang=js"
export * from "./PDPGalleryModal.vue?vue&type=script&lang=js"
import style0 from "./PDPGalleryModal.vue?vue&type=style&index=0&id=1d4a42de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a42de",
  null
  
)

export default component.exports